import React, { useCallback } from 'react'
import { useMuiSelectUtils } from 'scenes/Dashboard/components-next/Inputs/Select/Select.hook'

import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

import { ScoutingCampaignStatus } from '../../../../../../entities-next/scoutingCampaign'

export type ScoutingCampaignStatusSelectorProps = {
  status?: ScoutingCampaignStatus
  onChange: (newSearch: ScoutingCampaignStatus) => void
}

export const ScoutingCampaignStatusSelector = React.memo(
  ({ onChange, status }: ScoutingCampaignStatusSelectorProps) => {
    const menuItemsData = React.useMemo(
      () => [
        { value: '', text: 'All status' },
        { value: ScoutingCampaignStatus.inactive, text: 'Inactive' },
        { value: ScoutingCampaignStatus.draft, text: 'Draft' },
        { value: ScoutingCampaignStatus.deliveryPhase, text: 'SC - Delivery' },
        { value: ScoutingCampaignStatus.calibrationPhase, text: 'SC - Calibration' },
        { value: ScoutingCampaignStatus.pendingValidation, text: 'SC - Pending Validation' },
        { value: ScoutingCampaignStatus.lsRunning, text: 'LS - Running' },
        { value: ScoutingCampaignStatus.lsCompleted, text: 'LS - Completed' },
        { value: ScoutingCampaignStatus.ddPendingValidation, text: 'DD - Pending Validation' },
        { value: ScoutingCampaignStatus.ddCompleted, text: 'DD - Completed' },
        { value: ScoutingCampaignStatus.ddRunning, text: 'DD - Running' },
      ],
      []
    )
    const selected = status ?? ''
    const { getItem, selectedItem, setSelectedItem } = useMuiSelectUtils(menuItemsData, selected)

    const onSelectChange = useCallback(
      (event: SelectChangeEvent<{ name?: string; value: unknown }>) => {
        const status = event.target.value as ScoutingCampaignStatus
        onChange(status)
        setSelectedItem(status)
      },
      [onChange]
    )

    return (
      <Select
        variant="standard"
        onChange={onSelectChange}
        value={getItem(selectedItem)}
        renderValue={() => getItem(selectedItem)?.text}
      >
        {menuItemsData.map((m) => (
          <MenuItem key={m.value} value={m.value}>
            {m.text}
          </MenuItem>
        ))}
      </Select>
    )
  }
)

ScoutingCampaignStatusSelector.displayName = 'ScoutingCampaignStatusSelector'
